export const blockIconsPhotoandimagePaletteNew = (
	<span className='material-symbols-outlined'>palette</span>
);
